import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failurelistCourseMaster,
    successlistCourseMaster,
    getCourseMasterById,
} from "./ListCourseMasterSlice";
import { failureaddCourseMaster, successaddCourseMaster } from "./AddCourseMasterSlice";
import { ICourseMaster } from "../../../Pages/CourseMaster/ICourseMaster";

const ListCourseMasterApi = (action: PayloadAction<any>) => {
    return api.get("/api/course", {
        params: action.payload,
    });
};

const GetCourseMasterByIdApi = (action: PayloadAction<string>) => {
    return api.get("/api/course", {
        params: { course_id: action.payload },
    });
};

export function* GetCourseMasterByIdCall(action: PayloadAction<string>) {
    try {
        const response: AxiosResponse = yield call(GetCourseMasterByIdApi, action);
        yield put(successlistCourseMaster(response.data));
    } catch (error) {
        yield put(failurelistCourseMaster(error));
    }
}

export function* ListCourseMasterCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(ListCourseMasterApi, action);
        yield put(successlistCourseMaster(response.data));
    } catch (error) {
        yield put(failurelistCourseMaster(error));
    }
}

// Consolidated add / edit / delete — id present = edit, is_delete: true = delete
const AddCourseMasterApi = (action: PayloadAction<ICourseMaster>) => {
    const formData = new FormData();
    const payload = action.payload;

    if (payload.id !== undefined && payload.id !== null) formData.append("id", String(payload.id));
    if (payload.full_name) formData.append("full_name", payload.full_name);
    if (payload.short_name) formData.append("short_name", payload.short_name);
    if (payload.course_id !== undefined && payload.course_id !== null) formData.append("course_id", String(payload.course_id));
    if (payload.course_category_id !== undefined && payload.course_category_id !== null) formData.append("course_category_id", String(payload.course_category_id));
    if (payload.description !== undefined && payload.description !== null) formData.append("description", payload.description);
    if ((payload as any).duration !== undefined && (payload as any).duration !== null) formData.append("duration", String((payload as any).duration));
    if (payload.status !== undefined && payload.status !== null) formData.append("status", payload.status ? "1" : "0");
    if (payload.is_delete !== undefined && payload.is_delete !== null) formData.append("is_delete", payload.is_delete ? "1" : "0");
    if (payload.year_group_id !== undefined && payload.year_group_id !== null) formData.append("year_group_id", String(payload.year_group_id));
    if (payload.yeargroup_country_map_id !== undefined && payload.yeargroup_country_map_id !== null) formData.append("yeargroup_country_map_id", String(payload.yeargroup_country_map_id));
    if (payload.yeargroup_country_map !== undefined && payload.yeargroup_country_map !== null) formData.append("yeargroup_country_map", JSON.stringify(payload.yeargroup_country_map));
    
    if (payload.image) {
        formData.append("image", payload.image);
    }

    if (payload.subject_resources) {
        formData.append("subject_resources", JSON.stringify(payload.subject_resources));
    }

    return api.post("/api/course/create_edit", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export function* AddCourseMasterCall(action: PayloadAction<ICourseMaster>) {
    try {
        const response: AxiosResponse = yield call(AddCourseMasterApi, action);
        yield put(successaddCourseMaster(response.data));
    } catch (error) {
        yield put(failureaddCourseMaster(error));
    }
}
